/*
 * IMPORTS
 */
import { gql } from "@apollo/client"; // Npm: Apollo client for handling graphql request.

/*
 * EXPORTS
 */
export default gql`
  mutation RatePlanUploadMutation(
    $rateId: String!
    $replaceAll: Boolean
    $thumbnailStoredAt: Csv
  ) {
    RatePlanUpload(
      rateId: $rateId
      replaceAll: $replaceAll
      thumbnailStoredAt: $thumbnailStoredAt
    ) {
      message
      status
    }
  }
`;
